import { defineStore } from "pinia";
import { useCommonStore } from "@/stores/common";

const env = import.meta.env;
const api_host = env.VITE_APP_API_HOST;
export const useUserStore = defineStore("user", {
  state: () => {
    return {
      id: "",
      name: "",
      mobile: "",
      hospital: "",
      hospitals: "",
      is_lead: "",
      position: "",
      role: "",
    };
  },
  getters: {
    // 是否登录
    isLogin(state) {
      // console.log(state.id,'登录打印')
      return state.id ;
    }
  },
  actions: {
    // 登录
    login(mobile, code) {
      return new Promise(async (resolve, reject) => {
        try {
          // const res = await datasheet.records.query({
          //   filterByFormula: `AND({姓名} = '${name}',{手机号}= '${mobile}' )`
          // });
          const commonStore = useCommonStore();
          let res = await commonStore.getUser(mobile,code);

          if (res.result === "success") {
            let fields = res.data;
            console.log(fields,'this');
            // 填充每一个字段
            for (let key in fields) {
              this[key] = fields[key];
            }
            // console.log(this,'111');
            sessionStorage.setItem("isLogin", "success");
            console.log(fields,'登录成功')
            resolve(res); // 登录成功，解析 Promise 并传递 true
          } else {
            resolve(res); // 登录失败，解析 Promise 并传递 false
          }
        } catch (error) {
          reject(error); // 异常发生，拒绝 Promise 并传递错误
        }
      });
    },
    loginapp(name, mobile) {
      return new Promise(async (resolve, reject) => {
        try {
          // const res = await datasheet.records.query({
          //   filterByFormula: `AND({姓名} = '${name}',{手机号}= '${mobile}' )`
          // });
          const commonStore = useCommonStore();
          let res = await commonStore.getUserapp(name, mobile);

          if (res.result === "success") {
            let fields = res.data;
            console.log(fields,'this');
            // 填充每一个字段
            for (let key in fields) {
              this[key] = fields[key];
            }
            // console.log(this,'111');
            sessionStorage.setItem("isLogin", "success");
            console.log(fields,'登录成功')
            resolve(res); // 登录成功，解析 Promise 并传递 true
          } else {
           
            resolve(res); // 登录失败，解析 Promise 并传递 false
          }
        } catch (error) {
          reject(error); // 异常发生，拒绝 Promise 并传递错误
        }
      });
    },
    // 退出
    logout() {
      this.id = null;
      return true;
    },
    //获取医院患者数量
    getHospitals: async () => {
      let res = await fetch(`${api_host}api/field/hospitals`, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        }
      });
      //类似axios 中JSON.parse(res)
      res = await res.json();
       
      // console.log(res)
      if (res.result === "success") {
        return res;
      }
      return [];
    },
  },
  persist: true
});
